import { AccessorsMutatorsDecorator } from '../../helpers';
import { TranslatableModel } from './translatable-model';
import { PropertyAccommodationType } from './property-accommodation-type.model';

/**
 * @class BaseRate
 * @property {number} id
 * @property {Property} property
 * @property {string} name
 */
export class BaseRate extends TranslatableModel {

    /**
     * @type {string[]}
     */
    static get translatableAttributes() {

        return ['name'];
    }

    static get defaults() {
        return {
            min_los: 1,
            closed_to_arrival: false,
            closed_to_departure: false,
            additional_charge: false,
        };
    }

    fill(attribute = {}) {

        super.fill(attribute);

        Object
            .keys(this.constructor.defaults)
            .forEach(key => angular.isUndefined(this[key]) ? this[key] = this.constructor.defaults[key] : null);

        if (angular.isString(this.start_date)) {

            this.start_date = new Date(this.start_date);
        }

        if (angular.isString(this.end_date)) {

            this.end_date = new Date(this.end_date);
        }
    }

    /**
     * @param {Object|PropertyAccommodationType} value
     * @returns {PropertyAccommodationType}
     */
    setAccommodationType(value) {

        return value instanceof PropertyAccommodationType ? value : new PropertyAccommodationType(value);
    }

    static get validationModel() {

        return {
            name: {
                label: 'INTERVAL_NAME_IN_ENGLISH',
                commonLabel: 'Interval Name'
            },
            name_ar: {
                label: 'INTERVAL_NAME_IN_ARABIC',
                commonLabel: 'Interval Name'
            }
        };
    }
}

AccessorsMutatorsDecorator(
    'id',
    'old_id',
    ...BaseRate.translatableAttributesWithLanguageAliases,
    'accommodation_type',
    'start_date',
    'end_date',
    'min_los',
    'max_los',
    'closed_to_arrival',
    'closed_to_departure',
    'additional_charge',
    'pricing',
    'force',
    'from_calendar',
)(BaseRate);



// WEBPACK FOOTER //
// ./src/pms-api/models/base-rate.model.js